import { DataModel } from "common/models/utility-models/base-model";

export class AppVersionModel extends DataModel {
    app_version: any = '';
    app_type: any = '';
    force_update: any = '';
}